import React, { useState, useContext } from 'react'
import { useLocation, Redirect, withRouter } from 'react-router-dom'
import { UserContext } from '../../wrappers/UserContext'

const Login = withRouter(({ history }) => {
    const { user, setUser } = useContext(UserContext)
    const [loginClass, setLoginClass] = useState('is-active')
    const [signupClass, setSignupClass] = useState(null)
    const location = useLocation()

    if (location.pathname !== '/login') {
        history.replace('/login')
    }

    const temporary = () => {
        setUser('user')
    }
    const handleClick = (event) => {
        if (event.target.outerText === 'LOGIN') {
            setLoginClass('is-active')
            setSignupClass(null)
        } else {
            setSignupClass('is-active')
            setLoginClass(null)
        }
    }

    if (user) {
        return (
            <Redirect
                to={{
                    pathname: `/`,
                }}
            />
        )
    }

    return (
        <div className="section">
            <h2 className="title">Workflow Management</h2>
            <div className="forms-section">
                <section className="forms">
                    <div className={`form-wrapper ${loginClass}`}>
                        <button
                            type="button"
                            className="button switcher switcher-login title is-3"
                            onClick={handleClick}
                        >
                            Login
                        </button>
                        <div className="columns is-centered">
                            <div className="column is-4">
                                <form action="" className="form form-login box">
                                    <div className="field">
                                        <label className="label">Email</label>
                                        <div className="control has-icons-left">
                                            <input
                                                type="email"
                                                name="email"
                                                placeholder="you@gmail.com"
                                                className="input"
                                                required
                                            />
                                            <span className="icon is-small is-left">
                                                <i className="fa fa-envelope"></i>
                                            </span>
                                        </div>
                                    </div>
                                    <div className="field">
                                        <label className="label">
                                            Password
                                        </label>
                                        <div className="control has-icons-left">
                                            <input
                                                type="password"
                                                name="passoword"
                                                placeholder="*******"
                                                className="input"
                                            />
                                            <span className="icon is-small is-left">
                                                <i className="fa fa-lock"></i>
                                            </span>
                                        </div>

                                        {/* <Link to="route/will/exist">  */}
                                        <button
                                            // onClick={temporary}
                                            className="button is-small is-inverted"
                                        >
                                            Forgot Password?
                                        </button>
                                        {/* </Link> */}
                                        <br />
                                    </div>
                                    <div className="field">
                                        <label
                                            name="remember"
                                            className="checkbox label"
                                        >
                                            {`Remember Me `}
                                            <input
                                                type="checkbox"
                                                className="check"
                                            />
                                        </label>
                                    </div>
                                    <div className="field submit has-text-centered">
                                        <button
                                            onClick={temporary}
                                            className="button is-primary is-outlined"
                                        >
                                            Login
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                    <div className={`form-wrapper ${signupClass}`}>
                        <button
                            type="button"
                            className="button switcher switcher-signup title is-3"
                            onClick={handleClick}
                        >
                            Sign Up
                        </button>
                        <div className="columns is-centered">
                            <div className="column is-4">
                                <form
                                    action=""
                                    className="box form form-signup"
                                >
                                    <div className="field">
                                        <label className="label">Email</label>
                                        <div className="control has-icons-left">
                                            <input
                                                type="email"
                                                name="email"
                                                placeholder="you@gmail.com"
                                                className="input"
                                                required
                                            />
                                            <span className="icon is-small is-left">
                                                <i className="fa fa-envelope"></i>
                                            </span>
                                        </div>
                                    </div>
                                    <div className="field">
                                        <label className="label">
                                            Password
                                        </label>
                                        <div className="control has-icons-left">
                                            <input
                                                type="password"
                                                name="passoword"
                                                placeholder="*******"
                                                className="input"
                                                required
                                            />
                                            <span className="icon is-small is-left">
                                                <i className="fa fa-lock"></i>
                                            </span>
                                        </div>
                                        <div className="field">
                                            <label className="label">
                                                Confirm Password
                                            </label>
                                            <div className="control has-icons-left">
                                                <input
                                                    type="password"
                                                    name="passoword-confirm"
                                                    placeholder="*******"
                                                    className="input"
                                                    required
                                                />
                                                <span className="icon is-small is-left">
                                                    <i className="fa fa-lock"></i>
                                                </span>
                                            </div>
                                        </div>
                                        <div className="field">
                                            <label
                                                name="remember"
                                                className="checkbox label"
                                            >
                                                {`Remember Me `}
                                                <input
                                                    type="checkbox"
                                                    className="check"
                                                />
                                            </label>
                                        </div>
                                        <div className="field submit has-text-centered">
                                            <button
                                                onClick={temporary}
                                                className="button is-outlined is-primary"
                                            >
                                                Sign Up
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    )
})

export default Login
